export const translations = {
  id: {
    waMessage: "Halo Natama Trans Asia, saya ingin menanyakan ketersediaan armada.",
    tagline: "Transportasi Darat Terpercaya",
    headerCta: "Pesan Sekarang",
    nav: [
      { id: "armada", label: "Armada" },
      { id: "layanan", label: "Layanan" },
      { id: "keunggulan", label: "Keunggulan" },
      { id: "galeri", label: "Galeri" },
      { id: "kontak", label: "Kontak" },
    ],
    hero: {
      overline: "PT. Natama Trans Asia",
      lines: ["Bepergian Bersama,", "Nyaman Sampai", "Tujuan."],
      sub: "Big Bus, Medium Bus, dan Hiace untuk pariwisata, perjalanan dinas, sekolah, hingga acara khusus — harga transparan, pemesanan semudah satu pesan WhatsApp.",
      ctaPrimary: "Pesan via WhatsApp",
      ctaSecondary: "Lihat Armada",
      stats: [
        { v: "3", l: "Jenis Armada" },
        { v: "24/7", l: "Siap Dihubungi" },
        { v: "100%", l: "Harga Transparan" },
      ],
    },
    marquee: ["Jakarta", "Bandung", "Yogyakarta", "Bali", "Surabaya", "Malang", "Semarang", "Lombok"],
    fleet: {
      overline: "Armada Kami",
      title: "Satu Mitra, Semua Kebutuhan Rombongan",
      sub: "Dari tur lintas kota hingga antar-jemput privat — pilih armada yang paling pas untuk perjalanan Anda.",
      cta: "Tanya Ketersediaan",
      items: [
        {
          key: "bigbus",
          name: "Big Bus",
          seats: "50–59 Kursi",
          desc: "Andalan rombongan besar untuk pariwisata lintas kota, ziarah, dan study tour — kabin lapang dengan kenyamanan maksimal sepanjang perjalanan.",
          features: ["AC & Reclining Seat", "Bagasi Ekstra Luas", "Hiburan TV & Audio", "Pengemudi Berpengalaman"],
        },
        {
          key: "mediumbus",
          name: "Medium Bus",
          seats: "27, 33 & 39 Kursi",
          desc: "Lincah untuk grup menengah: antar-jemput karyawan, kegiatan kampus, hingga wisata keluarga besar ke berbagai destinasi.",
          features: ["AC Dingin Merata", "Kabin Lega & Bersih", "Fleksibel di Jalan Kota", "Bagasi Memadai"],
        },
        {
          key: "hiace",
          name: "Toyota Hiace",
          seats: "15 Kursi",
          desc: "Fleksibel dan privat untuk perjalanan dinas, keluarga, atau grup kecil yang membutuhkan mobilitas cepat tanpa repot.",
          features: ["Interior Nyaman", "Cocok Grup Kecil", "Efisien Jarak Jauh", "Privat & Fleksibel"],
        },
      ],
    },
    services: {
      overline: "Layanan",
      title: "Untuk Setiap Keperluan Perjalanan",
      sub: "Satu pintu untuk semua kebutuhan transportasi darat Anda.",
      items: [
        { key: "wisata", icon: "palmtree", title: "Pariwisata", desc: "Transportasi wisata ke destinasi favorit di seluruh Indonesia — dari city tour hingga tur lintas pulau." },
        { key: "korporat", icon: "briefcase", title: "Dinas & Korporat", desc: "Antar-jemput karyawan, kunjungan kerja, dan kebutuhan mobilitas perusahaan yang andal dan tepat waktu." },
        { key: "sekolah", icon: "gradcap", title: "Sekolah & Kampus", desc: "Study tour, field trip, dan kegiatan kampus dengan standar keamanan dan pengawasan tinggi." },
        { key: "agen", icon: "route", title: "Agen Perjalanan", desc: "Mitra armada tepercaya untuk biro dan agen perjalanan, dengan harga kerja sama yang kompetitif." },
        { key: "acara", icon: "sparkles", title: "Acara Khusus", desc: "Pernikahan, gathering, dan acara keluarga — tamu Anda tiba bersama, tanpa repot." },
      ],
    },
    why: {
      overline: "Kenapa Kami",
      title: "Duduk Santai, Sisanya Kami yang Ukur",
      items: [
        { title: "Keamanan Jadi Prioritas", desc: "Pengemudi berpengalaman dan armada yang melewati pengecekan berkala sebelum setiap keberangkatan." },
        { title: "Harga Transparan", desc: "Penawaran jelas sejak awal — tanpa biaya tersembunyi, tanpa kejutan di akhir perjalanan." },
        { title: "Pemesanan Semudah Chat", desc: "Cukup satu pesan WhatsApp, tim kami bantu pilih armada dan susun penawaran terbaik." },
        { title: "Armada Selalu Prima", desc: "Perawatan rutin dan kabin yang bersih, wangi, dan siap jalan kapan pun Anda butuh." },
      ],
    },
    gallery: {
      overline: "Galeri",
      title: "Momen di Setiap Perjalanan",
      sub: "Potret armada dan destinasi yang telah kami layani.",
    },
    testimonials: {
      overline: "Testimoni",
      title: "Kata Mereka yang Sudah Berangkat",
      items: [
        { quote: "Armada bersih, sopir ramah, dan selalu tepat waktu. Perjalanan dinas kami jadi jauh lebih mudah.", name: "Andini R.", role: "HR Perusahaan Swasta" },
        { quote: "Harga jelas di awal, tidak ada biaya tersembunyi. Sudah tiga kali memakai Natama untuk study tour sekolah.", name: "Budi S.", role: "Guru SMA" },
        { quote: "Respons WhatsApp cepat dan proses pemesanan sangat mudah. Andalan kami untuk rombongan besar.", name: "Maria L.", role: "Agen Perjalanan" },
      ],
    },
    contact: {
      overline: "Kontak",
      title: "Siap Berangkat? Hubungi Kami.",
      sub: "Tim kami siap membantu memilih armada dan menyusun penawaran terbaik untuk perjalanan Anda.",
      whatsappLabel: "Kontak Utama — WhatsApp",
      whatsappNote: "Respons cepat, setiap hari",
      phoneLabel: "Telepon / WhatsApp",
      phoneNote: "Hubungi via telepon atau WhatsApp",
      emailLabel: "Email",
      instagramLabel: "Instagram",
      instagramNote: "Ikuti kabar & promo terbaru",
      addressLabel: "Alamat Kantor",
      addressNote: "Klik untuk buka di Google Maps",
      mapTitle: "Temukan Kami di Peta",
      cta: "Chat WhatsApp Sekarang",
    },
    footer: {
      big: "Mari Bicara",
      sub: "Ceritakan rencana perjalanan Anda — kami siapkan armadanya.",
      explore: "Jelajahi",
      contact: "Kontak",
      rights: "© 2026 PT. Natama Trans Asia. Seluruh hak cipta dilindungi.",
    },
  },
  en: {
    waMessage: "Hello Natama Trans Asia, I would like to ask about fleet availability.",
    tagline: "Trusted Land Transportation",
    headerCta: "Book Now",
    nav: [
      { id: "armada", label: "Fleet" },
      { id: "layanan", label: "Services" },
      { id: "keunggulan", label: "Why Us" },
      { id: "galeri", label: "Gallery" },
      { id: "kontak", label: "Contact" },
    ],
    hero: {
      overline: "PT. Natama Trans Asia",
      lines: ["Travel Together,", "Arrive in", "Comfort."],
      sub: "Big Bus, Medium Bus, and Hiace for tourism, corporate travel, school trips, and special events — transparent pricing, booking as easy as one WhatsApp message.",
      ctaPrimary: "Book via WhatsApp",
      ctaSecondary: "View Fleet",
      stats: [
        { v: "3", l: "Fleet Types" },
        { v: "24/7", l: "Always Reachable" },
        { v: "100%", l: "Transparent Pricing" },
      ],
    },
    marquee: ["Jakarta", "Bandung", "Yogyakarta", "Bali", "Surabaya", "Malang", "Semarang", "Lombok"],
    fleet: {
      overline: "Our Fleet",
      title: "One Partner for Every Group Journey",
      sub: "From cross-city tours to private shuttles — choose the vehicle that fits your trip best.",
      cta: "Check Availability",
      items: [
        {
          key: "bigbus",
          name: "Big Bus",
          seats: "50–59 Seats",
          desc: "The go-to for large groups: cross-city tourism, pilgrimages, and study tours — a spacious cabin with maximum comfort all the way.",
          features: ["AC & Reclining Seats", "Extra-Wide Luggage", "TV & Audio Entertainment", "Experienced Drivers"],
        },
        {
          key: "mediumbus",
          name: "Medium Bus",
          seats: "27, 33 & 39 Seats",
          desc: "Agile for mid-size groups: employee shuttles, campus activities, and big family trips to any destination.",
          features: ["Evenly Cool AC", "Spacious, Clean Cabin", "City-Road Friendly", "Ample Luggage Space"],
        },
        {
          key: "hiace",
          name: "Toyota Hiace",
          seats: "15 Seats",
          desc: "Flexible and private for business trips, families, or small groups that need fast, hassle-free mobility.",
          features: ["Comfortable Interior", "Ideal for Small Groups", "Long-Distance Efficient", "Private & Flexible"],
        },
      ],
    },
    services: {
      overline: "Services",
      title: "For Every Kind of Journey",
      sub: "One stop for all your land transportation needs.",
      items: [
        { key: "wisata", icon: "palmtree", title: "Tourism", desc: "Travel transport to favorite destinations across Indonesia — from city tours to cross-island trips." },
        { key: "korporat", icon: "briefcase", title: "Corporate & Business", desc: "Employee shuttles, business visits, and reliable, on-time corporate mobility." },
        { key: "sekolah", icon: "gradcap", title: "Schools & Campuses", desc: "Study tours, field trips, and campus activities with high safety and supervision standards." },
        { key: "agen", icon: "route", title: "Travel Agents", desc: "A trusted fleet partner for travel bureaus and agencies, with competitive partnership rates." },
        { key: "acara", icon: "sparkles", title: "Special Events", desc: "Weddings, gatherings, and family events — your guests arrive together, hassle-free." },
      ],
    },
    why: {
      overline: "Why Us",
      title: "Sit Back — We Handle the Rest",
      items: [
        { title: "Safety Comes First", desc: "Experienced drivers and vehicles that pass routine checks before every departure." },
        { title: "Transparent Pricing", desc: "Clear quotes from the start — no hidden fees, no surprises at the end of the trip." },
        { title: "Booking as Easy as Chat", desc: "Just one WhatsApp message — our team helps pick the vehicle and craft the best offer." },
        { title: "Always Pristine Fleet", desc: "Routine maintenance and cabins that are clean, fresh, and ready whenever you are." },
      ],
    },
    gallery: {
      overline: "Gallery",
      title: "Moments From Every Journey",
      sub: "A glimpse of our fleet and the destinations we have served.",
    },
    testimonials: {
      overline: "Testimonials",
      title: "Words From Those Who've Traveled",
      items: [
        { quote: "Clean vehicles, friendly drivers, always on time. Our business trips became so much easier.", name: "Andini R.", role: "HR, Private Company" },
        { quote: "Clear pricing upfront, no hidden fees. We've used Natama three times for school study tours.", name: "Budi S.", role: "High School Teacher" },
        { quote: "Fast WhatsApp responses and a very easy booking process. Our go-to for large groups.", name: "Maria L.", role: "Travel Agent" },
      ],
    },
    contact: {
      overline: "Contact",
      title: "Ready to Go? Talk to Us.",
      sub: "Our team is ready to help you choose the right vehicle and craft the best offer for your journey.",
      whatsappLabel: "Main Contact — WhatsApp",
      whatsappNote: "Fast response, every day",
      phoneLabel: "Phone / WhatsApp",
      phoneNote: "Reach us by phone or WhatsApp",
      emailLabel: "Email",
      instagramLabel: "Instagram",
      instagramNote: "Follow for news & promos",
      addressLabel: "Office Address",
      addressNote: "Tap to open in Google Maps",
      mapTitle: "Find Us on the Map",
      cta: "Chat on WhatsApp Now",
    },
    footer: {
      big: "Let's Talk",
      sub: "Tell us your travel plan — we'll prepare the fleet.",
      explore: "Explore",
      contact: "Contact",
      rights: "© 2026 PT. Natama Trans Asia. All rights reserved.",
    },
  },
};
